import { object, string } from "yup";

import { OSOS_PROVIDERS } from "@/features/OsosOnboarding/OsosOnboarding.constants";
import { TDistributionCompany } from "@/features/OsosOnboarding/OsosOnboarding.types";

export const validations = object().shape({
  name: string().required(),
  city: string().required(),
  wiringNumber: string().when(["$distributionCompanies", "city"], ([distCompanies, city], schema) => {
    const selectedCompany = distCompanies?.find((item: TDistributionCompany) => item.provinces.includes(city));
    if (selectedCompany?.ososProvider === OSOS_PROVIDERS.GRIDBOX) {
      return string().required();
    }
    return schema;
  }),
  ososUsername: string().required(),
  ososPassword: string().required(),
});
